import { FC, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Unstable_Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { subscribeNewsletterMinimal } from "src/api/api";
import { Stack } from "@mui/material";

export const PostNewsletter: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [message, setMessage] = useState<string | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement>
  ): Promise<void> => {
    e.preventDefault();
    setMessage(undefined);

    // Basic validation
    if (!email || !name) {
      setError("Please provide both name and email.");
      return;
    }

    setIsLoading(true);
    try {
      const result = await subscribeNewsletterMinimal({ email, name });
      if (result.ok) {
        setMessage(result.message);
        setError(undefined);
        setEmail("");
        setName("");
      } else {
        setError(result.error);
      }
    } catch (err) {
      console.error(err);
      setMessage(
        "An error occurred while subscribing. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card
      elevation={16}
      sx={{
        py: 10,
        px: 8,
      }}
    >
      <Grid container spacing={3}>
        <Grid
          xs={12}
          md={6}
          sx={{
            order: {
              xs: 1,
              md: 0,
            },
          }}
        >
          <Typography variant="h4">Join the email list</Typography>
          <Typography
            color="text.secondary"
            variant="body2"
            sx={{
              mb: 3,
              mt: 1,
            }}
          >
            Subscribe to our newsletter to make sure you don&apos;t miss
            anything.
          </Typography>
          {isLoading && <Typography>Loading...</Typography>}
          {!message && !isLoading && (
            <Stack spacing={1}>
              <TextField
                fullWidth
                label="Name"
                name="Name"
                sx={{ flexGrow: 1 }}
                type="name"
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                fullWidth
                label="Email address"
                name="email"
                sx={{ flexGrow: 1 }}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
              />

              <Button
                onClick={(e) => handleSubmit(e)}
                fullWidth
                size="large"
                variant="contained"
              >
                Subscribe
              </Button>
              {error && (
                <Typography color="error" variant="body2">
                  {error}
                </Typography>
              )}
            </Stack>
          )}
          {message && !isLoading && (
            <Typography
              color="text.secondary"
              sx={{
                mt: 2,
              }}
              variant="body2"
            >
              {message}
            </Typography>
          )}
        </Grid>
        <Grid
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src="/assets/iconly/iconly-glass-volume.svg"
            sx={{
              maxWidth: "100%",
              width: 260,
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
